import React, { useState, useEffect, useRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Logo from 'src/components/Logo';
import Button from '@material-ui/core/Button';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import 'src/theme/index.css';
import SearchFiltersDrawer from 'src/components/AnageImoveis/SearchFiltersDrawer';
import { ReactComponent as ArrowDown } from 'src/assets/images/icons/arrow-down.svg';

import { Link } from '@material-ui/core';

function Header() {
  const [showDropdown, setShowDropdown] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [isSearchFiltersDrawerOpen, setIsSearchFiltersDrawerOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const closeDropdown = () => {
    setShowDropdown(false);
  };

  const toggleMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  const handleOnBuyPropertiesClick = (event) => {
    event.preventDefault();
    setShowMobileMenu(false);

    const inlineSearchFiltersEl = document.querySelector('.filters-section--inline');

    if (inlineSearchFiltersEl) {
      inlineSearchFiltersEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      setIsSearchFiltersDrawerOpen(true);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      <div id="main-header" className="header">
        <nav className="navbar navbar-expand-lg">
          <div className="container">
            <div className="header-content">
              <RouterLink to="/" className="navbar-brand">
                <Logo />
              </RouterLink>

              <Button
                className="btn mobile-menu-button d-lg-none"
                onClick={toggleMobileMenu}
              >
                <MenuIcon />
              </Button>

              {/* Desktop Horizontal Navigation */}
              <div className="horizontal-nav d-none d-lg-flex">
                <ul className="nav-list">
                  <li className="nav-item dropdown" ref={dropdownRef}>
                    <div className="nav-link" onClick={toggleDropdown}>
                      Institucional
                      <span className={`dropdown-arrow ${showDropdown ? 'open' : ''}`}>
                        <ArrowDown />
                      </span>
                    </div>
                    <div className={`dropdown-menu ${showDropdown ? 'show' : ''}`}>
                      <RouterLink to="/institucional" className="dropdown-item" onClick={closeDropdown}>
                        Sobre nós
                      </RouterLink>
                      <Link
                        href="https://anageimoveis.vagas.solides.com.br/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="dropdown-item"
                        onClick={closeDropdown}
                      >
                        Trabalhe Conosco
                      </Link>
                      <Link
                        href="https://www.anageimoveis.com.br/joinville"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="dropdown-item"
                        onClick={closeDropdown}
                      >
                        Imóveis em Joinville
                      </Link>
                      <Link
                        href="https://www.anageimoveis.com.br/blog"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="dropdown-item"
                        onClick={closeDropdown}
                      >
                        Blog
                      </Link>
                    </div>
                  </li>
                  <li className="nav-item">
                    <RouterLink to="/imoveis-favoritos" className="nav-link">
                      Meus Favoritos
                    </RouterLink>
                  </li>
                  <li className="nav-item">
                    <RouterLink to="/lancamentos/joinville" className="nav-link">
                      Lançamentos
                    </RouterLink>
                  </li>
                  <li className="nav-item">
                    <RouterLink to="/permutas" className="nav-link">
                      Permuta
                    </RouterLink>
                  </li>
                  <li className="nav-item">
                    <Link
                      href="https://www.anageimoveis.com.br/anuncie-seu-imovel"
                      className="nav-link"
                      target="_blank"
                    >
                      Vender Imóveis
                    </Link>
                  </li>
                </ul>

                {/* Divider and CTA Button outside nav-list */}
                <div className="nav-divider" />
                <RouterLink to="/comprar/joinville" className="nav-link comprar-btn" onClick={handleOnBuyPropertiesClick}>
                  Comprar Imóveis
                </RouterLink>
              </div>

              {/* Mobile Menu - Only show on mobile */}
              {showMobileMenu && (
              <div className="mobile-menu-overlay d-lg-none">
                <div className="mobile-menu-content">
                  <div className="mobile-menu-header">
                    <RouterLink to="/" className="mobile-logo" onClick={() => setShowMobileMenu(false)}>
                      <Logo />
                    </RouterLink>
                    <Button
                      className="btn mobile-menu-close"
                      onClick={toggleMobileMenu}
                    >
                      <CloseIcon />
                    </Button>
                  </div>
                  <nav className="mobile-nav">
                    <RouterLink to="/institucional" className="mobile-nav-link" onClick={() => setShowMobileMenu(false)}>
                      Sobre nós
                    </RouterLink>
                    <Link
                      href="https://anageimoveis.vagas.solides.com.br/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mobile-nav-link"
                      onClick={() => setShowMobileMenu(false)}
                    >
                      Trabalhe Conosco
                    </Link>
                    <Link
                      href="https://www.anageimoveis.com.br/joinville"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mobile-nav-link"
                      onClick={() => setShowMobileMenu(false)}
                    >
                      Imóveis em Joinville
                    </Link>
                    <Link
                      href="https://www.anageimoveis.com.br/blog"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mobile-nav-link"
                      onClick={() => setShowMobileMenu(false)}
                    >
                      Blog
                    </Link>
                    <RouterLink to="/imoveis-favoritos" className="mobile-nav-link" onClick={() => setShowMobileMenu(false)}>
                      Meus Favoritos
                    </RouterLink>
                    <RouterLink to="/lancamentos/joinville" className="mobile-nav-link" onClick={() => setShowMobileMenu(false)}>
                      Lançamentos
                    </RouterLink>
                    <RouterLink to="/permutas" className="mobile-nav-link" onClick={() => setShowMobileMenu(false)}>
                      Permuta
                    </RouterLink>
                    <Link
                      href="https://www.anageimoveis.com.br/anuncie-seu-imovel"
                      className="mobile-nav-link"
                      target="_blank"
                      onClick={() => setShowMobileMenu(false)}
                    >
                      Vender Imóveis
                    </Link>
                    <RouterLink to="/comprar/joinville" className="mobile-nav-cta" onClick={handleOnBuyPropertiesClick}>
                      Comprar Imóveis
                    </RouterLink>
                  </nav>
                </div>
              </div>
              )}
            </div>
          </div>
        </nav>
      </div>

      {isSearchFiltersDrawerOpen && (
        <SearchFiltersDrawer onClose={() => setIsSearchFiltersDrawerOpen(false)} />
      )}
    </>
  );
}

export default Header;
